import { useEffect, useState } from 'react';
import { HOMEPAGE_PRODUCT_LINEUP_TEMPLATE } from '../constants/homepageProducts';
import { enrichHomepageLineup } from '../lib/enrichHomepageLineup';
import { getSprintfitCatalogSingleton } from '../lib/sprintfitCatalogSingleton';

/**
 * Homepage shelf cards: prices/compare-at from live Shopify catalog (or catalog-fallback.json).
 */
export function useEnrichedHomepageLineup() {
  const [lineup, setLineup] = useState(() => enrichHomepageLineup(HOMEPAGE_PRODUCT_LINEUP_TEMPLATE, null));
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let cancelled = false;
    getSprintfitCatalogSingleton().then((cat) => {
      if (cancelled) return;
      setLineup(enrichHomepageLineup(HOMEPAGE_PRODUCT_LINEUP_TEMPLATE, cat));
      setStatus(cat && cat.length ? 'ok' : 'error');
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { lineup, status };
}
